import React from 'react'
import styled, { keyframes } from 'styled-components'

const fade = keyframes([], {
  '0%': { opacity: 0 },
  '20%': { opacity: 1 },
  '80%': { opacity: 1 },
  '100%': { opacity: 0 }
})

const duration = ({ duration }) => ({
  animationDuration: duration + 'ms'
})

const playState = ({ playState }) => ({
  animationPlayState: playState
})

const Fade = styled.div(
  [],
  {
    animationName: fade,
    animationTimingFunction: 'ease-in-out',
    animationIterationCount: 'infinite'
  },
  duration,
  playState
)

export default class Fader extends React.Component {
  static defaultProps = {
    duration: 3000
  }

  state = {
    count: 0,
    playState: 'paused'
  }

  inc = () => {
    this.setState(state => ({ count: state.count + 1 }))
  }

  componentDidMount () {
    const { duration } = this.props
    this.counter = setInterval(this.inc, duration)
    this.setState({ playState: 'running' })
  }

  componentWillUnmount () {
    setInterval(this.counter)
  }

  render () {
    const { duration } = this.props
    const { count, playState } = this.state
    const children = React.Children.toArray(this.props.children)
    const i = count % children.length
    const current = children[i]
    return (
      <Fade playState={playState} duration={duration}>
        {current}
      </Fade>
    )
  }
}
